import { TbArrowsExchange } from 'react-icons/tb'
import { P } from '~/components-v2'
import {
  CompareGrid,
  CompareItem,
  CompareQuote,
  ComparisonCard,
  OmniLogo,
  StrategyLogo,
} from '~/components-v2/compete-comparison-card'

export const CompareCard2 = () => {
  return (
    <ComparisonCard
      className="icon-pink"
      icon={<TbArrowsExchange />}
      title="Your migration date is set. Omni can help you build something better that lasts."
      subhead="Either path is a rebuild. Your reports and permissions get re-created in a new environment whether you move to their cloud or to Omni. The difference is what you land on: a platform scaling back on-prem support and no longer pushing perpetual licenses, or one where BI is the entire business."
    >
      <CompareGrid
        id="omni-migration"
        compareLogos={[<OmniLogo key={1} />, <StrategyLogo key={2} />]}
        compareItems={[
          [
            <CompareItem type="positive" key={1}>
              <P>
                <strong>Save time and start building now.</strong> Omni connects
                directly to your data warehouse, with no separate environment or
                server to build first. Your team can explore and build analytics
                right away.
              </P>
            </CompareItem>,
            <CompareItem type="negative" key={2}>
              <P>
                <strong>Support for the legacy platform ends in 2026.</strong>{' '}
                Paid extended support buys two more years of security patches,
                and nothing new. After 2028, the legacy platform is no longer
                supported.
              </P>
            </CompareItem>,
          ],
          [
            <CompareItem type="positive" key={1}>
              <P>
                <strong>Hands-on support through the move and beyond.</strong>{' '}
                <a href="https://omni.co/customer-support">
                  1:1 support and training
                </a>{' '}
                help your team migrate, launch, and keep improving.
              </P>
            </CompareItem>,
            <CompareItem type="negative" key={2}>
              <P>
                <strong>
                  A services engagement that ends on the same platform.
                </strong>{' '}
                There is no self-serve path to Strategy’s cloud; migration runs
                through their services team.
              </P>
            </CompareItem>,
          ],
          [
            <CompareItem type="positive" key={1}>
              <P>
                <strong>Your semantic model is code.</strong> It{' '}
                <a
                  href="https://docs.omni.co/integrations/git"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  syncs to Git
                </a>{' '}
                as plain files you can version, search, and take with you.
                Nothing about your work is trapped in the platform.
              </P>
            </CompareItem>,
            <CompareItem type="negative" key={2}>
              <P>
                <strong>Desktop authoring ended in March 2026.</strong> New
                versions can’t even open old local files. The classic admin
                toolchain is being retired.
              </P>
            </CompareItem>,
          ],
          [
            <CompareQuote
              key={1}
              type="positive"
              linkURL="https://omni.co/blog/case-study-cribl"
              linkLabel="Head of Data at Cribl"
              quote={
                <p>
                  We sent out a survey after the migration, and everyone was
                  really happy [...] One user even reached out to tell us Omni
                  was already saving them 15 hours per month. It’s been awesome
                  to see that validation across the business because we
                  ultimately want to save people time.
                </p>
              }
            />,
            <CompareQuote
              key={2}
              type="warn"
              linkURL="https://www.g2.com/products/strategy-one-formerly-microstrategy-one/reviews?order=most_recent"
              linkLabel="Strategy customer"
              quote={
                <p>
                  I wouldn’t say it was easy. [...] we have been working with
                  the migration team since last October, and we’re still trying
                  to work out some of the smaller kinks to get everything up and
                  running appropriately.
                </p>
              }
            />,
          ],
        ]}
      />
    </ComparisonCard>
  )
}
